export default __webpack_public_path__ + "static/media/serverbg3.baf01b4b.png";